import React from "react"
import LogrosInnovadores from "../assets/images/capacidades/logros/Logros.png"
import originalidad from "../assets/images/capacidades/logros/originalidad.png"
import alineacionEstrategia from "../assets/images/capacidades/logros/alineacion.png"
import impactoMedible from "../assets/images/capacidades/logros/impacto.png"
import caracteristicas from "../assets/images/capacidades/logros/caracteristicas.png"
import video from "../assets/images/capacidades/logros/video.png"

export default [
  {
    titulo: "LoGros innovadores",
    img: LogrosInnovadores,
  },
  {
    titulo: "Características",
    img: caracteristicas,
  },
  {
    titulo: "1. Originalidad",
    subtitulo: "Originalidad",
    descripcion: (
      <ul>
        <li>- Grado de novedad de la solución</li>
        <li>- Una forma novedosa de enfrentar el problema</li>
        <li>- Solución nunca antes implementada en Grupo Familia</li>
      </ul>
    ),
    img: originalidad,
  },
  {
    titulo: "2. Alineación con la estrategia",
    subtitulo: "Alineación con la estrategia",
    descripcion: (
      <ul>
        <li>- La sostenibilidad financiera, personas y/o entorno</li>
        <li>- La excelencia y la productividad</li>
        <li>- Mercadeo y ventas</li>
      </ul>
    ),
    img: alineacionEstrategia,
  },
  {
    titulo: "3. Impacto medible",
    subtitulo: "Impacto medible",
    descripcion: (
      <ul>
        <li>- Sostenibilidad (ahorros, nuevos materiales)</li>
        <li>- Finanzas (impacto de los indicadores financieros)</li>
        <li>- Personas (cultura, bienestar, liderazgo, seguridad)</li>
        <li>- Entorno (medio ambiente, social)</li>
        <li>- Mercado (mercado,ventas)</li>
        <li>- Eficiencia (productividad, tiempos de proceso)</li>
      </ul>
    ),
    img: impactoMedible,
  },
  {
    titulo: "Video LoGros",
    img: video,
    video: "https://jwp.io/s/dKQQ5a8c",
  },
]
